<template>
  <div class="CollectPages">
    <div class="container">
      <div class="row">
        <div class="col-md-8" style="margin: 0 auto">
          <!-- <mt-header title="观看时长">
      <router-link to slot="left">
        <mt-button icon="back" @click.native="$router.back(-1)">返回</mt-button>
      </router-link>
          </mt-header>-->
          <Search :pages="routeLive" />
          <div class="CollectCount">
            <P>
              您已收藏了
              <span>{{ dataForm.totalCount }}</span
              >场直播
            </P>
          </div>
          <!-- <div v-show="dataForm.collectList.length <= 0" class="noCollect">
            <p>美好的事物总被珍藏，请别错过！</p>
          </div> -->
          <div
            v-for="(item, i) in dataForm.collectList"
            :key="i"
            class="CollectList"
            @click="getLiveDetail(item.liveId)"
          >
            <div class="liveImg">
              <img :src="item.liveCoverImg" alt />
              <div class="liveStatus">
                {{
                  item.liveStatus === 0
                    ? '即将直播'
                    : item.liveStatus === 1
                    ? '直播中'
                    : '历史直播'
                }}
              </div>
            </div>

            <div>
              <p>{{ item.liveName }}</p>
              <p>{{ item.liveLecturers }}</p>
              <!-- <span>{{item.createTime.substring(0,11)}}收藏</span> -->
              <div class="infoItemDes2" v-if="item.liveStatus === 0">
                <span>开始时间：{{ item.liveStartTime.substring(0, 19) }}</span>
              </div>
              <div class="infoItemDes2" v-if="item.liveStatus === 1">
                <span>结束时间：{{ item.liveEndTime.substring(0, 19) }}</span>
              </div>
            </div>
          </div>
          <div
            v-if="pageIndex < dataForm.totalPage"
            style="
              text-align: center;
              font-size: 12px;
              color: #666;
              margin-top: 10px;
            "
            @click="loadMore"
          >
            点击加载更多...
          </div>
          <div
            v-else
            style="
              text-align: center;
              font-size: 12px;
              color: #666;
              margin-top: 40px;
              padding-bottom: 50px;
            "
          >
            暂无更多数据...
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Search from '../../components/Search'
export default {
  components: { Search },
  data() {
    return {
      dataForm: {
        currPage: 0,
        collectList: [],
        pageSize: 0,
        totalCount: 0,
        totalPage: 0
      },
      pageIndex: 1,
      busy: false,
      userId: '',
      routeLive: ''
    }
  },

  mounted() {
    this.routeLive = sessionStorage.getItem('routeLive')
    this.userId = sessionStorage.getItem('userId')
    this.getCollectList()
    this.noShare()
  },
  methods: {
    // 跳转到直播详情
    getLiveDetail(liveId) {
      // this.$router.push('/details/' + liveId)
      // this.$router.push({
      //   path: '/details',
      //   query: {
      //     liveId: liveId,
      //   },
      // })
      const routeData = this.$router.resolve({
        path: '/details',
        query: {
          liveId: liveId
        }
      })
      window.open(routeData.href, '_blank')
    },
    // 加载更多
    loadMore() {
      this.pageIndex++
      if (this.pageIndex <= this.dataForm.totalPage) {
        this.getCollectList()
      }
    },
    // 获取当前用户的收藏列表
    getCollectList() {
      if (!this.userId) {
        return this
      }
      this.$http({
        url: `/live/userInterest/queryOKLives`,
        method: 'get',
        params: {
          pageNo: this.pageIndex,
          userId: this.userId,
          status: 2,
          pageSize: 10
        }
      }).then(({ data }) => {
        if (data && data.code === 0) {
          if (data.data) {
            this.dataForm.collectList = this.dataForm.collectList.concat(
              data.data.records
            )
            this.dataForm.pageSize = data.data.pageSize
            this.dataForm.totalCount = data.data.total
            this.dataForm.totalPage = data.data.pages
            this.dataForm.currPage = data.data.current
          }
        } else {
          this.dataForm.collectList = []
          this.pageIndex = 1
        }
      })
    },
    getIndex() {
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss" scoped>
.infoItemDes2 {
  // line-height: 15px;
  color: #666;
  overflow: hidden;
  font-size: 10px;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  // margin: 5px 0;
}
.noCollect {
  text-align: center;
  height: 300px;
  line-height: 300px;
}
.CollectCount {
  line-height: 40px;
  background-color: #eee;
  font-size: 14px;
  padding-left: 1.5rem;
  color: #666;
  height: 40px;
  p {
    span {
      padding: 0 5px;
      font-size: 18px;
    }
  }
}
.CollectList {
  padding: 1rem;
  display: flex;
  background-color: #fff;
  border-bottom: 1px solid #eee;
  align-items: center;
  img {
    width: 100px;
    height: 75px;
    border-radius: 3px;
    margin-right: 2rem;
  }
  .liveImg {
    position: relative;
    .liveStatus {
      position: absolute;
      right: 20px;
      bottom: 0;
      color: #fff;
      padding: 2px 1rem;
      border-radius: 1rem;
      font-size: 12px;
      background-color: rgba($color: #000000, $alpha: 0.8);
    }
  }

  div {
    p:nth-child(1) {
      font-size: $font-title2;
      line-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      display: -webkit-box;
      -webkit-box-orient: vertical;
    }
    p:nth-child(2),
    span {
      color: #666;
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 1;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      // margin: 5px 0;
    }
    span {
      color: #333;
    }
  }
}
</style>
